export interface Category {
  slug: string;
  name: string;
  desc: string;
  icon: string;
  color: string;
  subcategories: string[];
}

export const categories: Category[] = [
  {
    slug: "star",
    name: "明星动态",
    desc: "第一时间追踪明星行程、恋情与合作动态，掌握偶像的每一次公开亮相。",
    icon: "ri-user-star-line",
    color: "primary",
    subcategories: ["恋情曝光", "婚变传闻", "行程路透", "代言合作"],
  },
  {
    slug: "film",
    name: "影视评论",
    desc: "院线电影、热播剧集的深度解析与口碑观察，帮你在观影前先做功课。",
    icon: "ri-film-line",
    color: "accent",
    subcategories: ["院线电影", "剧集热播", "纪录片", "口碑争议"],
  },
  {
    slug: "influencer",
    name: "网红热点",
    desc: "直播带货、短视频达人与流量话题的实时追踪，看懂网络红人的起落。",
    icon: "ri-live-line",
    color: "secondary",
    subcategories: ["直播带货", "短视频达人", "争议翻车", "涨粉神话"],
  },
  {
    slug: "event",
    name: "热点事件",
    desc: "颁奖典礼、红毯现场与行业突发热议，一网打尽当下最受关注的娱乐事件。",
    icon: "ri-fire-line",
    color: "accent",
    subcategories: ["颁奖典礼", "红毯现场", "行业风波", "突发热议"],
  },
  {
    slug: "variety",
    name: "综艺节目",
    desc: "热门综艺的赛制看点、嘉宾阵容与名场面盘点，轻松追综不迷路。",
    icon: "ri-tv-2-line",
    color: "primary",
    subcategories: ["竞技综艺", "慢综艺", "脱口秀", "嘉宾阵容"],
  },
  {
    slug: "music",
    name: "音乐现场",
    desc: "新歌首发、演唱会与音乐节现场速递，感受舞台与旋律的真实温度。",
    icon: "ri-music-2-line",
    color: "secondary",
    subcategories: ["新歌发布", "演唱会", "音乐节", "音乐榜单"],
  },
  {
    slug: "fashion",
    name: "时尚穿搭",
    desc: "红毯造型、明星街拍与潮流单品解析，学明星穿出自己的风格。",
    icon: "ri-t-shirt-line",
    color: "primary",
    subcategories: ["红毯造型", "明星街拍", "品牌代言", "美妆护肤"],
  },
  {
    slug: "gossip",
    name: "八卦爆料",
    desc: "圈内爆料、幕后花絮与关系解读，和瓜友们一起理性吃瓜。",
    icon: "ri-chat-smile-2-line",
    color: "accent",
    subcategories: ["圈内爆料", "幕后花絮", "关系解读", "往期回顾"],
  },
];